export const uk = {
    dayBudgetMode: 'Режим показа',
    perDay: 'в день'
};
